<template>
  <div @click="onClose" id="modal_wrap">
    <div class="modal_container">
      <button @click="() => onClose(null)" class="btn btn-default closeBtn">
        <i class="icon-fa icon-fa-remove"/></button>
      <div class="modal_header" v-if="modalData?.header">
        <h4>{{ modalData?.header }}</h4>
      </div>
      <div class="modal_body">
        <slot/>
      </div>
      <div class="modal_footer" v-if="!modalData?.disableFooter">
        <div class="flex justify-content-end">
          <button @click="() => onClose(null)" class="btn btn-default">Отмена</button>
          <vue-ladda
            type="submit"
            button-class="btn btn-success"
            @click="onAccept"
            data-style="zoom-in"
            :loading="acceptBtnLoading"
          >Ok
          </vue-ladda>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import {Datetime} from "vue-datetime";

export default {
  components: {
    VueLadda,
    Datetime
  },
  data() {
    return {
      acceptBtnLoading: false,
      errorMessage: null
    };
  },
  props: ["onModalClose", "onModalAccept", "modalData", 'type'],
  watch: {
    modalData() {
      // console.log('changed');
    }
  },
  mounted() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "hidden";
  },
  beforeDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
  },
  methods: {
    onAccept(e) {
      // this.acceptBtnLoading = true;
      this.onModalAccept();
    },
    onReject(e) {
      if (!this.acceptBtnLoading) {
        this.onModalClose();
      }
    },
    onClose(e) {
      if (
        !e || (!this.acceptBtnLoading &&
          e.target.id === "modal_wrap" &&
          !this.acceptBtnLoading)
      ) {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        this.onModalClose();
      }
    }
  }
};
</script>

<style>
.modal_body p {
  margin-bottom: 2px;
}

#modal_wrap .comments .badge {
  background-color: #d0d0d0;
}

#modal_wrap .comments .badge.active {
  background-color: #006cc7;
  color: white;
}

#modal_wrap .comments {
  padding: 5px;
  border: 1px solid lightblue;
  text-align: left;
}

#modal_wrap .comments .comment .date,
#modal_wrap .comments .comment .author {
  font-size: 10px;
}

#modal_wrap .comments .comment .date {
  text-align: right;
}
</style>

<style scoped>
.btn-xs {
  font-size: 12px;
  padding: 1px 8px !important;
  margin: 0;
  margin-bottom: 5px;
}

.modal_container {
  max-height: 100%;
  overflow: hidden;
  overflow-y: auto;
  overflow-x: auto;
}

.swal2-icon {
  margin: 5px 3px !important;
}

.error_messages {
  color: red;
}

.phoneCall_btn {
  margin: 10px;
  padding: 7px 25px;
  font-size: 24px;
}

#modal_wrap {
  display: none;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.55);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_body {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}

.modal_header {
  position: relative;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.modal_actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
}

.closeBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9;
}

.modal_container {
  background-color: white;
  padding: 20px;
  min-width: 80%;
  min-height: 330px;
  width: fit-content;
  position: relative;
}
</style>
